module.exports = __webpack_public_path__ + "media/assets/images/flags/kn-40d7781795a046093c89efa7cb39018c.svg";